import API from './API.ts'
import axios from 'axios'
import { getDynamicHeaders } from './httpHeaders.ts'

export default {
  getSeriesSettings () { return API.httpClient.get('accounting/series-settings') },
  updateSeriesSettings (settings) { return API.httpClient.put('accounting/series-settings', settings) },
  getFortnoxReadiness () { return API.httpClient.get('accounting/fortnox/readiness', { timeout: 120000 }) },
  getFortnox () {
    return API.httpClient.get('accounting/fortnox')
  },
  authorizeFortnox () {
    return API.httpClient.post('accounting/fortnox/authorize')
  },
  completeFortnoxConnection (state, code) {
    // Keep the authorization code out of the shared client's request/error logging.
    return axios.create(API.httpClient.defaults).post('accounting/fortnox/callback', { state, fortnox_authorization_code: code }, { headers: getDynamicHeaders() })
  },
  getBookExportSettings () {
    return API.httpClient.get('accounting/book-export-settings')
  },
  updateBookExportSettings (settings) {
    return API.httpClient.put('accounting/book-export-settings', settings)
  },
  disconnectFortnox () {
    return API.httpClient.delete('accounting/fortnox')
  },
  sendToFortnox (exportId) {
    return API.httpClient.post(`accounting/book-exports/${exportId}/fortnox`)
  },
  getFortnoxVouchers (exportId, page = 1) {
    return API.httpClient.get(`accounting/book-exports/${exportId}/fortnox`, { params: { page } })
  },
  //
  // GET
  //
  getBookExports (statusOnly = false, ids = []) {
    return API.httpClient.get('accounting/book-exports', { params: { fortnox_status_only: statusOnly, ...(statusOnly ? { ids } : {}) } })
  },
  getAccounts () {
    return API.httpClient.get('accounting/accounts')
  },
  getIncomeAccounts () {
    return API.httpClient.get('accounting/income-accounts')
  },
  getProfitCenters () {
    return API.httpClient.get('accounting/profit-centers')
  },
  getAccountActivityAccounts () {
    return API.httpClient.get('accounting/account-activity/accounts')
  },
  getAccountActivity ({ accountId, requestId, offset, visibleEntries }) {
    return API.httpClient.get('accounting/account-activity', {
      params: {
        account_id: accountId,
        request_id: requestId,
        offset,
        visible_entries: visibleEntries
      }
    })
  },
  downloadAccountActivity ({ accountId, startDate, endDate }) {
    return API.httpClient.get('accounting/account-activity/export', {
      params: {
        account_id: accountId,
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      },
      responseType: 'blob'
    })
  },
  downloadReceivablesFile ({ date, fileFormat }) {
    return API.httpClient.get('reports/receivables-report', {
      params: {
        date: date.format('YYYY-MM-DD'),
        file_format: fileFormat
      }
    })
  },
  downloadCustomerCreditsFile ({ date, fileFormat }) {
    return API.httpClient.get('reports/customer-credits-report', {
      params: {
        date: date.format('YYYY-MM-DD'),
        file_format: fileFormat
      }
    })
  },
  getReceivablesData ({ date }) {
    return API.httpClient.get('reports/get-receivables-data', {
      params: {
        date: date.format('YYYY-MM-DD')
      }
    })
  },
  getCustomerCreditsData ({ date }) {
    return API.httpClient.get('reports/get-customer-credits-data', {
      params: {
        date: date.format('YYYY-MM-DD')
      }
    })
  },

  //
  // POST
  //
  createBookExport ({ mode, date }) {
    return API.httpClient.post('accounting/create-book-export', {
      mode,
      date: date.format('YYYY-MM-DD')
    })
  },
  updateBookExportReportSetting (enabled) {
    return API.httpClient.post('accounting/book-export-report-setting', { enabled })
  },
  createIncomeAccount ({ accountNumber, name, taxId }) {
    return API.httpClient.post('accounting/create-income-account', {
      account_number: accountNumber,
      name,
      tax_id: taxId
    })
  },
  createProfitCenter ({ code, name }) {
    return API.httpClient.post('accounting/profit-centers', { code, name })
  },
  renameProfitCenter (id, name) {
    return API.httpClient.patch(`accounting/profit-centers/${id}`, { name })
  },
  assignProfitCenterAccounts (id, accountIds) {
    return API.httpClient.put(`accounting/profit-centers/${id}/accounts`, { account_ids: accountIds })
  },
  deleteProfitCenter (id) {
    return API.httpClient.delete(`accounting/profit-centers/${id}`)
  }
}
